export default __webpack_public_path__ + "static/media/telegram.94a002ef.webp";